module.exports = __webpack_public_path__ + "static/seth_tucker-35573cd11b5d2ce399217526553b7660.jpg";